// ✅ EditForm.js
import React from 'react';

function EditForm({ form, onChange, onSubmit }) {
  return (
    <form onSubmit={onSubmit} className="space-y-4">
      <input
        name="name"
        value={form.name}
        onChange={onChange}
        className="w-full px-4 py-2 border rounded"
        placeholder="이름"
      />

      <input
        name="email"
        type="email"
        value={form.email}
        onChange={onChange}
        className="w-full px-4 py-2 border rounded"
        placeholder="이메일"
      />

      <textarea
        name="desc"
        value={form.desc}
        onChange={onChange}
        className="w-full px-4 py-2 border rounded"
        placeholder="자기소개"
        rows={4}
      />

      <button type="submit" className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700">
        저장
      </button>
    </form>
  );
}

export default EditForm;